import { actionTypes, } from '../constants';
export const initialState = {
    list: [],
    extension: null,
    statistics: null,
    institutions: [],
};
export const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.GET_EXTENSIONS_LIST:
            return setExtensionsList(state, payload);
        case actionTypes.GET_EXTENSIONS_BY_ID:
            return setExtension(state, payload);
        case actionTypes.CLEAR_EXTENSION:
            return clearExtension(state);
        case actionTypes.GET_STATISTICS:
            return setExtensionStatistics(state, payload);
        case actionTypes.CLEAR_STATISTICS:
            return clearExtensionStatistics(state);
        case actionTypes.SET_INSTITUTIONS_LIST:
            return setInstitutionsList(state, payload);
        default:
            return state;
    }
};
function setExtensionsList(state, payload) {
    return {
        ...state,
        list: payload,
    };
}
function setExtension(state, payload) {
    return {
        ...state,
        extension: payload,
    };
}
function clearExtension(state) {
    return {
        ...state,
        extension: null,
    };
}
function setExtensionStatistics(state, payload) {
    return {
        ...state,
        statistics: payload,
    };
}
function clearExtensionStatistics(state) {
    return {
        ...state,
        statistics: null,
    };
}
function setInstitutionsList(state, payload) {
    return {
        ...state,
        institutions: payload,
    };
}
export default reducer;
